import React, { useState } from 'react';
import DataTable from '../../../components/DataTable';
import DownClickablePopup from '../../../components/DownClickablePopup';

// Sample detail record
const subscriptionDetail = {
    customerName: 'John Doe',
    customerContact: 'johndoe@gmail.com\n+00 0000000000',
    donationTime: '04/08/2025 08:00 am',
    donationFor: { title: 'New Program', type: 'Programs' },
    amount: '$1,000.00',
    paymentModifier: 'Match Fee',
    paymentMethod: 'AID PAY CC',
    nextChargeDate: '05/07/2025',
    subscriptionStatus: 'Active',
};

// Sample automatic charges data
const chargeRecords = Array.from({ length: 8 }).map((_, i) => ({
    chargeId: `pi_3RBlb0GO6v1RAKQY0Ew3tm${i}`,
    date: '04/08/2025 08:00 am',
    donationFor: { title: 'New Program', type: 'Programs' },
    amount: { donation: '$900.00', fee: '$100.00', total: '$1,000.00' },
    paymentMethod: 'AID PAY CC',
    paymentStatus: ['Complete', 'Incomplete', 'Pending', 'Processing', 'Refunded'][i % 5],
}));

export default function SubscriptionDetailsPage() {
    const [search, setSearch] = useState('');
    const [sortOption, setSortOption] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [filterOption, setFilterOption] = useState(null);
    const filteredCharges = chargeRecords.filter(r =>
        r.chargeId.includes(search)
    );

    const detailColumns = [
        { key: 'label', title: '', render: () => null },
    ];

    const chargeColumns = [
        {
            key: 'chargeId',
            title: 'CHARGE ID',
            render: (v) => <div style={styles.chargeId}>{v}</div>
        },
        { key: 'date', title: 'DATE' },
        {
            key: 'donationFor',
            title: 'DONATION FOR',
            render: (_, row) => (
                <>
                    <div>Title: {row.donationFor.title}</div>
                    <div>Type: {row.donationFor.type}</div>
                </>
            )
        },
        {
            key: 'amount',
            title: 'DONATION AMOUNT',
            render: (_, row) => (
                <>
                    <div>Donation Amount: {row.amount.donation}</div>
                    <div>Fee: {row.amount.fee}</div>
                    <div>Total Amount: {row.amount.total}</div>
                </>
            )
        },
        { key: 'paymentMethod', title: 'PAYMENT METHOD' },
        {
            key: 'paymentStatus',
            title: 'PAYMENT STATUS',
            render: (status) => {
                const colorMap = {
                    Complete: '#4caf50',
                    Incomplete: '#f44336',
                    Pending: '#d6c104',
                    Processing: '#9c27b0',
                    Refunded: '#2196f3',
                };
                return (
                    <span style={{ ...styles.statusPill, backgroundColor: colorMap[status] || '#ccc' }}>
                        {status}
                    </span>
                );
            }
        },
    ];

    const sortOptions = [
        'Donation Time - Ascending',
        'Donation Time - Descending',
        'Donation Amount - Ascending',
        'Donation Amount - Descending',
    ];

    const filterOptions = [
        'All Statuses',
        'Active',
        'Inactive',
    ];
    const sortHtml = sortOptions.map((option, index) => (
        <div
            key={index}
            className={`sort-option ${sortOption === option ? 'sort-option-selected' : ''}`}
            // onClick={() => handleSortChange(option)}
        >
            <span className="sort-option-radio"></span>
            <span>{option}</span>
        </div>
    ));

    const filterHtml = filterOptions.map((option, index) => (
        <div
            key={index}
            className={`sort-option ${filterOption === option ? 'sort-option-selected' : ''}`}
            // onClick={() => handleFilterChange(option)}
        >
            <span className="sort-option-radio"></span>
            <span>{option}</span>
        </div>
    ));

    return (
        <div style={styles.container}>
            <div style={styles.toolbar}>
                <h1 style={styles.title}>Subscriptions</h1>
                <div style={styles.rightSideFilter}>
                    <div style={styles.searchWrapper}>
                        <span className="material-icons" style={styles.searchIcon}>search</span>
                        <input
                            type="text"
                            placeholder="Search..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            style={styles.searchInput}
                        />
                    </div>
                    <DownClickablePopup popUpTitle={'Filter'} filters={filterHtml}>
                        <button style={styles.iconBtn}>
                            <span className="material-icons">filter_list</span>
                        </button>
                    </DownClickablePopup>
                    <DownClickablePopup popUpTitle={'Sort'} filters={sortHtml}>
                        <button style={styles.iconBtn}>
                            <span className="material-icons">sort</span>
                        </button>
                    </DownClickablePopup>
                </div>
            </div>
            <div style={styles.detailCard}>
                <div style={styles.cardHeader}>
                    <h2 style={styles.cardTitle}>Subscription Details</h2>
                    <button style={styles.editBtn} title="Edit">
                        <span className="material-icons">edit</span>
                    </button>
                </div>
                <div style={styles.detailGrid}>
                    <div>
                        <div style={styles.detailLabel}>Customer Name</div>
                        <div style={styles.detailValue}>{subscriptionDetail.customerName}</div>
                    </div>
                    <div>
                        <div style={styles.detailLabel}>Customer Email/Phone Number</div>
                        <div style={styles.detailValue}>
                            {subscriptionDetail.customerContact.split('\n').map((line, i) => <div key={i}>{line}</div>)}
                        </div>
                    </div>
                    <div>
                        <div style={styles.detailLabel}>Donation Time</div>
                        <div style={styles.detailValue}>{subscriptionDetail.donationTime}</div>
                    </div>
                    <div>
                        <div style={styles.detailLabel}>Donation For</div>
                        <div style={styles.detailValue}>Title: {subscriptionDetail.donationFor.title}</div>
                        <div style={styles.detailValue}>Type: {subscriptionDetail.donationFor.type}</div>
                    </div>
                    <div>
                        <div style={styles.detailLabel}>Donation Amount</div>
                        <div style={styles.detailValue}>{subscriptionDetail.amount}</div>
                    </div>
                    <div>
                        <div style={styles.detailLabel}>Payment Modifier</div>
                        <div style={styles.detailValue}>{subscriptionDetail.paymentModifier}</div>
                    </div>
                    <div>
                        <div style={styles.detailLabel}>Payment Method</div>
                        <div style={styles.detailValue}>{subscriptionDetail.paymentMethod}</div>
                    </div>
                    <div>
                        <div style={styles.detailLabel}>Next Charge Date</div>
                        <div style={styles.detailValue}>{subscriptionDetail.nextChargeDate}</div>
                    </div>
                    <div>
                        <div style={styles.detailLabel}>Subscription Status</div>
                        <span style={{ ...styles.statusPill, backgroundColor: subscriptionDetail.subscriptionStatus === 'Active' ? '#c8e6c9' : '#ffcdd2' }}>
                            {subscriptionDetail.subscriptionStatus}
                        </span>
                    </div>
                </div>
            </div>

            <h2 style={styles.sectionTitle}>Automatic Charges and Change Records</h2>
            <DataTable data={filteredCharges} columns={chargeColumns} rowKey="chargeId" />
        </div>
    );
}

const styles = {
    container: { fontFamily: 'Arial, sans-serif', color: '#333' },
    headerTitle: { margin: 0, marginBottom: 16, fontSize: 24 },
    detailCard: { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginBottom: 24 },
    cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
    cardTitle: { margin: 0, fontSize: 18 },
    editBtn: { background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: '#555' },
    detailGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gap: '26px',
        padding: '10px 0px'
    },
    detailLabel: { fontSize: 12, color: '#666', marginBottom: 4 },
    detailValue: { fontSize: 14, color: '#000' },
    statusPill: { display: 'inline-block', padding: '8px 16px', borderRadius: 12, fontSize: 12, color: '#fff' },
    sectionTitle: { marginTop: 0, marginBottom: 12, fontSize: 20 },
    toolbar: { display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '8px',
        flexDirection: 'row'},
    rightSideFilter: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    searchWrapper: {
        position: 'relative',
        width: 240,
    },
    searchIcon: {
        position: 'absolute',
        top: '8px',
        left: '8px',
        color: 'rgb(153, 153, 153)',
    },
    searchInput: {
        width: '100%',
        padding: '10px 9px 10px 32px',
        borderRadius: '4px',
        border: '1px solid rgb(204, 204, 204)',
        fontSize: '16px',
    },
    iconBtn: {
        cursor: 'pointer',
        fontSize: '24px',
        color: 'rgb(0, 0, 0)',
        background: '#fff',
        display: 'flex',
        padding: '5px',
        border: 'solid 1px #ccc',
    },
};
